export const sortAlphabeticallyAscending = (arr) => {
    return arr.sort((a, b) => {
        const lowerA = a.children.name.toLowerCase();
        const lowerB = b.children.name.toLowerCase();
        if (lowerA < lowerB) {
            return -1;
        }
        if (lowerA > lowerB) {
            return 1;
        }
        return 0;
    });
}
export const sortAlphabeticallyDescending = (arr) => {
    return arr.sort((a, b) => {
        const lowerA = a.children.name.toLowerCase();
        const lowerB = b.children.name.toLowerCase();
        if (lowerA > lowerB) {
            return -1;
        }
        if (lowerA < lowerB) {
            return 1;
        }
        return 0;
    });
}